// Save Password / Remember Me as reported to, and pre-filled from, the AmbiFi mobile app.
//
// The checkboxes are kept per user in local storage ("<username>;savePassword"), but that key is only written when the
// user types a password or toggles a box. When the app pre-fills saved credentials neither happens, so the stored value
// is null even though the form shows the default (on, unless the device is shared). Reporting that null made the app
// treat Save Password as off and delete the saved login on every other sign-in.

function toFlag(value) {
	if (value === true || value === "true") {
		return true;
	}
	if (value === false || value === "false") {
		return false;
	}
	return null;
}

// The effective value: what the user chose (stored), else what the form currently shows, else the default.
export function resolveCredentialFlag(storedValue, stateValue, sharedDevice) {
	const stored = toFlag(storedValue);
	if (stored !== null) {
		return stored;
	}
	const current = toFlag(stateValue);
	if (current !== null) {
		return current;
	}
	return !sharedDevice;
}

// What the mobile app receives about saved credentials. The password goes along only when it is to be saved, so a
// shared device or a user who turned Save Password off never has it sent to the app.
export function buildMobileCredentialInfo({ password, storedSavePassword, storedRememberMe, stateSavePassword, stateRememberMe, sharedDevice }) {
	const savePassword = resolveCredentialFlag(storedSavePassword, stateSavePassword, sharedDevice);
	const rememberMe = resolveCredentialFlag(storedRememberMe, stateRememberMe, sharedDevice);
	const info = { savePassword, rememberMe };
	if (savePassword && !sharedDevice && password) {
		info.scr = password;
	}
	return info;
}
